import styled, { css } from 'styled-components';

export const StepperBox = styled.div`
  background: #091413;
  border-radius: 11px;
  padding: 11px 13px;
`;

export const StepperHeading = styled.div`
  font-family: var(--head);
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.4px;
  color: #c8a060;
  margin-bottom: 8px;
`;

export const StepRow = styled.div<{
  $done?: boolean;
  $active?: boolean;
  $opt?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 4px 0;
  font-size: 12.5px;
  line-height: 1.3;
  color: #5f7a6c;
  transition: color 0.2s;
  position: relative;

  ${({ $opt }) =>
    $opt &&
    css`
      font-style: italic;
      opacity: 0.8;
    `}

  ${({ $done }) =>
    $done &&
    css`
      color: #9fc7a6;
    `}

  ${({ $active }) =>
    $active &&
    css`
      color: #f4ead8;
      font-weight: 600;
    `}
`;

export const Dot = styled.span<{ $done?: boolean; $active?: boolean }>`
  flex-shrink: 0;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.13);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #8aa090;
  transition: all 0.2s;

  ${({ $done }) =>
    $done &&
    css`
      background: #2a5a10;
      border-color: #2a5a10;
      color: #cdf2a8;
    `}

  ${({ $active }) =>
    $active &&
    css`
      background: #ff7a10;
      border-color: #ff7a10;
      color: #fff;
      box-shadow: 0 0 0 3px rgba(255, 122, 16, 0.22);
    `}
`;

export const StepLabel = styled.span`
  flex: 1;
`;

export const StepHintWrap = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  flex-shrink: 0;
`;

export const StepHintDot = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #c8a060;
  font-family: var(--head);
  font-weight: 700;
  font-size: 10px;
  font-style: italic;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: help;
  flex-shrink: 0;
`;

export const StepHintPop = styled.span<{
  $visible: boolean;
  $top: number;
  $left: number;
}>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  transform: translateY(-50%);
  background: #091413;
  border: 1px solid #25382f;
  border-radius: 8px;
  padding: 7px 11px;
  font-size: 11.5px;
  color: #9fc7a6;
  white-space: nowrap;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  pointer-events: none;
  transition:
    opacity 0.15s,
    visibility 0.15s;
  z-index: 9999;
  font-style: normal;
  font-weight: 400;
`;
